<template>
    <div class="device-type-manange relative">
        <div class="buttons">
<!--            <el-button @click="resetForm">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
            <el-button :id="'roleAdd'" @click="addDeviceType">新增</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="app_source" label="来源" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="version_num" label="版本号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="site_name" label="地址服务器" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="create_date" label="创建时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="update_date" label="最后更新时间" align="center"
                             label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'roleEdit'" @click="goEdit(scope.row)" type="text">
                    编辑
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopDoctor(scope.row,0)" v-if="scope.row.status_number==1"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopDoctor(scope.row,1)" v-if="scope.row.status_number==0"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'roleDel'" @click="del_user(scope.row)" type="text">删除
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        data() {
            return {
                search_data: null,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                is_submit: false,
            };
        },
        mounted() {
            // 获取版本列表
            this.getList();
            localStorage.setItem('prev_page', 'version_list')
        },
        methods: {
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'versionListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].app_source) {
                            case '1':
                                res.data.data.list[i].app_source = 'Android';
                                res.data.data.list[i].app_source_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].app_source = 'IOS';
                                res.data.data.list[i].app_source_number = 2;
                                break;
                            case '3':
                                res.data.data.list[i].app_source = 'PC网页';
                                res.data.data.list[i].app_source_number = 3;
                                break;
                        }
                        switch (res.data.data.list[i].status) {
                            case '0':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 0;
                                break;
                            case '1':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 1;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },
            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 跳转编辑页
            goEdit(data) {
                this.$router.push({
                    name: "versionEdit",
                    params: {
                        id: data.id,
                        version_num: data.version_num,
                        version_result: data.version_result,
                        sites_id: data.sites_id,
                        app_source: data.app_source_number,
                        rewrite: parseInt(data.rewrite),
                        showupdate: parseInt(data.showupdate),
                        forceupdate: data.forceupdate,
                        update_content: data.update_content,
                        remark: data.remark,
                        app_download_url: data.app_download_url,
                    }
                });
            },
            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.search_data = "";
                this.getList();
            },
            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 跳转添加页
            addDeviceType() {
                this.$router.push({name: "versionAdd", params: {}});
            },

            // 删除设备类型
            del_user(val) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定该删除该版本吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'deleteAppVersion',
                        params: {
                            id: val.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message.success('删除成功！');
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 启用停用版本
            startStopDoctor(data, status) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (status == '0') {
                    var message = '确定启用该版本吗？';
                }
                if (status == '1') {
                    var message = '确定停用该版本吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminSystemServices',
                        method: 'startStopAppVersion',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";
</style>
